module.exports = __webpack_public_path__ + "img/order_mgmt_empty.a9512ea6.png";